export const DEFAULT_SCENARIO_NAME = 'New Scenario';
export const SCENARIO_NAME_MAX_LENGTH = 200;
